<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationRespectiveType")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="fitment.evaluationRespectiveType"
                                            :class="{invalid : $v.fitment.evaluationRespectiveType.$error}">
                                        <option :value="option.code" v-for="option in evaluationRespectiveTypes"
                                                :key="option.code">
                                            {{option.displayName}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.fitment.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationRespectiveType")}}
                                    </div>
                                </div>
                                <div class="form-row" v-if="isTenders">
                                    <div class="form-group col-md-4">
                                        <label>{{$t("realEstate.field.tenderContractDate")}} <span class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy"
                                                    v-model="tenderContractDate"
                                                    :date="tenderContractDate"
                                                    :clear-button="true"
                                                    :class="{invalid:$v.tenderContractDate.$error}"></datepicker>
                                        <div class="red" v-if="$v.tenderContractDate.$error">
                                            {{$t("realEstate.field.tenderContractDate")}}
                                        </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>
                                            {{$t("realEstate.field.tenderContractNumber")}} <span class="red">*</span>
                                        </label>
                                        <input type="text" class="form-control"
                                               :class="{invalid: $v.fitment.tenderContractNumber.$error}"
                                               v-model="fitment.tenderContractNumber">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.ownerClient")}} <span class="red">*</span></label>
                                    <v-select v-model="fitment.ownerClient" label="text"
                                              :options="owners"
                                              :filterable="false"
                                              @search="onOwnerSearch"
                                              @search:focus="onOwnerFocus"
                                              :class="{invalid : $v.fitment.ownerClient.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="fitment && fitment.ownerClient && fitment.ownerClient.text">
                                            <div v-html="fitment.ownerClient.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.fitment.ownerClient.$error">
                                        {{$t("realEstate.validation.ownerClient")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="hasPermission('NEW_FITMENT_WITH_LETTER_ATTORNEY')">
                                    <div class="form-check pl-0">
                                        <label class="form-check-label" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                            v-model="fitment.hasCustomerClient">
                                            <span class="form-check-sign"></span>
                                            {{$t("realEstate.field.withLetterOfAttorney")}}
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group" v-if="fitment.hasCustomerClient">
                                    <label>Буйюртмачи <span
                                            class="red">*</span></label>
                                    <v-select v-model="fitment.customerClient" label="text"
                                              :options="customers"
                                              :filterable="false"
                                              @search="onCustomerSearch"
                                              @search:focus="onCustomerFocus"
                                              :class="{invalid : $v.fitment.customerClient.$error}">
                                        <template slot="option" slot-scope="option" v-if="option && option.text">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="fitment && fitment.customerClient && fitment.customerClient.text">
                                            <div v-html="fitment.customerClient.text"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.fitment.customerClient.$error">
                                        Буйюртмачи
                                    </div>
                                </div>

                                <div class="form-group" v-if="fitment.hasCustomerClient">
                                    <label>Ишончнома номери: <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="fitment.powerOfAttorneyNumber"
                                           :class="{invalid : $v.fitment.powerOfAttorneyNumber.$error}"/>
                                    <div class="red" v-if="$v.fitment.powerOfAttorneyNumber.$error">Ишончнома номери
                                    </div>
                                </div>

                                <div class="form-group" v-if="fitment.hasCustomerClient">
                                    <label>Ишончнома санаси: <span class="red">*</span></label>
                                    <datepicker class="form-control" format="dd/MM/yyyy"
                                                v-model="powerOfAttorneyDate"
                                                :clear-button="true"
                                                :class="{invalid : $v.powerOfAttorneyDate.$error}"></datepicker>
                                    <div class="red" v-if="$v.powerOfAttorneyDate.$error">Ишончнома санаси:
                                    </div>
                                </div>

                                <template v-if="isOrgTypeMib">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibDebtorName")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="fitment.debtor"
                                               :class="{invalid : $v.fitment.debtor.$error}"/>
                                        <div class="red" v-if="$v.fitment.debtor.$error">
                                            {{$t("realEstate.validation.mibDebtorName")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterNumber")}} <span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="fitment.letterNumber"
                                               :class="{invalid : $v.fitment.letterNumber.$error}"/>
                                        <div class="red" v-if="$v.fitment.letterNumber.$error">
                                            {{$t("realEstate.validation.mibLetterNumber")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.mibLetterDate")}} <span
                                                class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="contractDate"
                                                    :clear-button="true"
                                                    :class="{invalid : $v.contractDate.$error}"></datepicker>
                                        <div class="red" v-if="$v.contractDate.$error">
                                            {{$t("realEstate.validation.mibLetterDate")}}
                                        </div>
                                    </div>
                                </template>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluationPurpose")}} <span
                                            class="red">*</span></label>
                                    <select class="form-control" v-model="fitment.evlGoalType"
                                            :class="{invalid : $v.fitment.evlGoalType.$error}">
                                        <option :value="option.key" v-for="option in goalTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.fitment.evlGoalType.$error">
                                        {{$t("realEstate.validation.evaluationPurpose")}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.propertyType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="fitment.evlPropertyType"
                                            :class="{invalid : $v.fitment.evlPropertyType.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.fitment.evlPropertyType.$error">
                                        {{$t("realEstate.validation.propertyType")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluator")}} <span class="red">*</span></label>
                                    <v-select v-model="fitment.employee" label="text"
                                              :options="employees"
                                              :filterable="false"
                                              @search="onEmployeeSearch"
                                              @search:focus="onEmployeeFocus"
                                              :class="{invalid : $v.fitment.employee.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="fitment && fitment.employee && fitment.employee.text">
                                            <div v-html="fitment.employee.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.fitment.employee.$error">
                                        {{$t("realEstate.validation.evaluator")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.contractAmount")}}</label>
                                    <numeric-input class="form-control" v-model="fitment.evlContractAmount"
                                                   :controls="false" :precision="2"
                                                   :disabled="isOrgType || isPaid"></numeric-input>

                                    <div v-if="isOwnerTypeLegal && !isOrgTypeMib">
                                        <label>Олдиндан тўлов фоизи 0% дан 100% гача!</label>
                                        <numeric-input class="form-control" v-model="fitment.prepayment"
                                                       :controls="false" :precision="2"></numeric-input>
                                    </div>

                                    <span style="color: green">ҚҚС билан: {{fitment.evlAmountToPay | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                    <div class="form-group" style="color: blue">
                                        <span>Туланган сумма: {{fitment.paidAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                    </div>

                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.evaluatorIdea")}}</label>
                                        <textarea type="text" class="form-control"
                                                  v-model="fitment.evaluatorIdea"></textarea>
                                    </div>

                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.evaluatorRestrictiveTerms")}}</label>
                                        <textarea type="text" class="form-control"
                                                  v-model="fitment.evaluatorRestrictiveTerms"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>{{$t("fitment.fitmentDocs")}}</h4>
                                </div>
                            </div>
                            <template v-if="(fitment.ownerClient || fitment.entiteCreateType === 'API_EXARID') && !isPageLoadInit">

                                    <AssetDropZone code="documentsDropZone" :label="documentOrPassportLbl"
                                                   folder="Letter" :folderName="'Fitment'"
                                                   :data="fitment.letterFiles"
                                                   @change="(files) => {fitment.letterFiles = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                                   :has-error="$v.fitment.letterFiles.$error"/>

                                    <template>
                                    <AssetDropZone code="actOfSaleDropZone" label="asset.actOfSale"
                                                   folder="ActOfSale"  :folderName="'Fitment'"
                                                   :data="fitment.actOfSaleFiles"
                                                   @change="(files) => {fitment.actOfSaleFiles = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                                   :has-error="$v.fitment.actOfSaleFiles.$error"/>
                                    <AssetDropZone code="decisionDropZone" label="asset.decision"
                                                   folder="Decision"  :folderName="'Fitment'"
                                                   :data="fitment.decisionFiles"
                                                   @change="(files) => {fitment.decisionFiles = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                                   :has-error="$v.fitment.decisionFiles.$error"/>
                                    <AssetDropZone code="playlistDropZone" label="asset.playlist"
                                                   folder="ExecutivePlaylist"  :folderName="'Fitment'"
                                                   :data="fitment.executivePlaylistFiles"
                                                   @change="(files) => {fitment.executivePlaylistFiles = files}"
                                                   :removeFile="canRemoveFile"
                                                   :editable="canSave"
                                    />

                                </template>
                            </template>
                        </div>

                        <div class="row" v-if="fitment.id && fitment.id > 0 && fitment.entiteCreateType !== 'INSIDE'">
                              <template>
                                  <PreviewDropZone code="checkPaymentDropZone" :label="checkPaymentLbl"
                                                   :data="fitment.checkPaymentFiles"
                                                   @change="(files) => {asset.checkPaymentFiles = files}"
                                  />
                              </template>
                              <div class="form-check checkbox-inline">
                                  <label class="form-check-label pl-3 font-weight-bold">
                                      <input class="form-check-input" type="checkbox"
                                             v-model="fitment.displayReport"
                                             @change="showReport()"
                                             v-bind:disabled="!hasPermission('NEW_FITMENT_DISPLAY_REPORT')"
                                      >
                                      <span class="form-check-sign"></span>
                                      {{$t("report.field.showReport")}}
                                  </label>
                              </div>
                        </div>

                        <div class="row">
                            <div class="col-12 col-md-6 mt-2">
                                <div class="form-group">
                                    <fitment-status-view :fitment="fitment" v-if="fitment.id"/>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 mt-2">
                                <div class="form-group">
                                    <fitment-history-view v-if="fitment.id"/>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="showReportButton">
                            <div class="col-12 btns-box">
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_REPORT_WORD_QR_CODE')"
                                        @click="reportDocQrCode(fitment)">
                                    <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWordQrCode")}}
                                </button>
                                <button
                                        class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_REPORT_WORD')"
                                        @click="reportDoc(fitment)">
                                    <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_REPORT_PDF_QR_CODE')"
                                        @click="reportPdfQrCode(fitment)">
                                    <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_REPORT_PDF')"
                                        @click="reportPdf(fitment)">
                                    <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_CONTRACT_PDF_QR_CODE')"
                                        @click="contractQrCodePdf(fitment)">
                                    <i v-if="loading.isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdfQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_CONTRACT_PDF')"
                                        @click="contractPdf(fitment)">
                                    <i v-if="loading.isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractPdf")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_CONTRACT_WORD_QR_CODE')"
                                        @click="contractDocQrCode(fitment)">
                                    <i v-if="loading.isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWordQrCode")}}
                                </button>
                                <button class="all-btn pull-right btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_CONTRACT_WORD')"
                                        @click="contractDoc(fitment)">
                                    <i v-if="loading.isCDocLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleContractWord")}}
                                </button>

                                <button class="btn btn-primary pull-right mr-2 btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_REPORT_PDF_NOT_SIGNED_AND_QRCODE')"
                                        @click="notSignedAndQRCodeReportPdf(fitment)">
                                    <i v-if="loading.isPdfNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.title")}}
                                </button>
                                <button
                                        class="btn btn-primary pull-right mr-2 btn-sm"
                                        v-if="hasPermission('NEW_FITMENT_REPORT_WORD_NOT_SIGNED_AND_QRCODE')"
                                        @click="notSignedAndQRCodeReportDoc(fitment)">
                                    <i v-if="loading.isDocNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                                    {{$t("realEstate.report.titleWord")}}
                                </button>
                            </div>
                        </div>

                        <div class="row" v-if="fitment.id && fitment.id > 0">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">
                                        {{$t("asset.assetToEvaluate")}}
                                    </h4>
                                    <button class="all-btn add-btn pull-right ml-2" v-if="canSave" @click="addFitment">
                                        {{$t("fitment.fitmentAdd")}}
                                    </button>
                                </div>
                                <div class="table-responsive">
                                    <div class="table-wrapper">
                                      <table class="table table-hover">
                                          <thead>
                                          <tr>
                                              <th width="5%">№</th>
                                              <th width="30%">Бошқа мол-мулк номи</th>
                                              <th width="15%">Киритилган сана</th>
                                              <th width="15%">Томонидан яратилган</th>
                                              <th width="15%">БАХОЛАНГАН ҚИЙМАТИ</th>
                                              <th width="100%">ЖАРАЁН</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="(item, index) in fitment.evaluationFitments" :key="item.id">
                                              <td>{{index+1}}#{{item.id}}</td>
                                              <td>{{item.name}}</td>
                                              <td>{{new Date(fitment.createDate) | dateFormat('DD/MM/YYYY')}}</td>
                                              <td>{{fitment.createUserName}}</td>
                                              <td>
                                                  {{item.totalGovPrice | currency('', 0, { thousandsSeparator: ' ' })}}
                                                  сўм
                                              </td>
                                              <td class="td-actions text-center direction-row">
                                                  <button @click="addEditPushItem(item.id, fitment.id)"
                                                          v-tooltip="'Ўзгартириш'"
                                                          class="all-btn dark-btn table-action">
                                                      <i class="fa fa-edit"></i>
                                                  </button>
                                                  <button type="button" v-tooltip="'Ўчириш'" v-if="canSave"
                                                          class="all-btn delete-btn table-action"
                                                          @click="showDeleteFitmentItemDialog(item, index)">
                                                      <i class="fa fa-times"></i>
                                                  </button>
                                              </td>
                                          </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing">
                                    {{$t("action.save")}}
                                </button>
                                <button class="all-btn" @click="changeStatus('Rated')" :disabled="processing" v-if="canEvaluate">
                                    {{$t("realEstate.action.evaluate")}}
                                </button>
                                <button class="all-btn add-btn" @click="changeStatus('Confirmed')" :disabled="processing"
                                        v-if="canConfirm && (fitment.appraiserReportEsp || !fitment.hasEsp)">
                                    {{$t("realEstate.action.confirm")}}
                                </button>
                                <button class="all-btn" @click="openSignPageAppraiser(fitment)" :disabled="processing"
                                        v-if="canConfirm && fitment.hasEsp && !fitment.appraiserReportEsp">
                                    Баҳоловчи тасдиқлаш (ЭЦП)
                                </button>
                                <button class="all-btn add-btn" @click="openSignPageDirector(fitment)"
                                        :disabled="processing"
                                        v-if="hasPermission('NEW_FITMENT_CONFIRM') && fitment.appraisalStatusEnum === 'Confirmed' && fitment.hasEsp && fitment.appraiserReportEsp && !fitment.directorReportEsp">
                                    Директор тасдиқлаш (ЭЦП)
                                </button>
                                <button class="all-btn edit-btn" @click="changeStatus('Unreviewed')"
                                        :disabled="processing" v-if="canReEvaluate">
                                    {{$t("realEstate.action.reevaluate")}}
                                </button>

                                <button class="all-btn delete-btn" @click="deleteFitment(fitment)"
                                        v-if="hasPermission('NEW_FITMENT_DELETE')">
                                    {{$t("realEstate.delete.title")}}
                                </button>

                                <button class="all-btn add-btn" @click="sendReportToMIBAsset(fitment)"
                                        v-if="hasPermission('NEW_FITMENT_SEND_TO_MIB') && isMib && fitment.appraisalStatusEnum === 'Confirmed'">
                                    {{$t("realEstate.action.sendReportToMIB")}}
                                </button>
                                <button class="all-btn ml-3" v-if="canSendAgent"
                                        :disabled="processing"
                                        @click="sendingExpert2ToAgent">
                                    {{$t('main.send')}}
                                </button>

<!--                                <button class="all-btn add-btn" v-if="canSendAgent"-->
<!--                                      @click="sendEvaluationObjectToIdentification(fitment)"-->
<!--                                      :disabled="processing"-->
<!--                                      >-->
<!--                                Идентификацияга бериш-->
<!--                                </button>-->

                                <button class="all-btn delete-btn" v-if="canReject" @click="rejectOrder">
                                    <i class="fa fa-reply-all"></i>
                                    <span>Рад қилиш</span>
                                </button>

                            </div>
                        </div>

                        <div class="row mt-3" v-if="fitment.appraisalStatusEnum === 'Confirmed'">
                            <div class="col">
                                <div class="alert alert-warning d-flex">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong>
                                        Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш
                                        тугмасини босинг!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <RejectComment/>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {numericTypes} from '@/shared/constants/mask'
    import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import {required, requiredUnless, minLength} from 'vuelidate/lib/validators';
    import {formatDate, parseDate} from '@/shared/utils';
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import FitmentStatusView from '@/views/fitment/FitmentStatusView.vue'
    import FitmentHistoryView from '@/views/fitment/FitmentHistoryView.vue'
    import RejectComment from '@/components/RejectComment';
    import {mapState} from "vuex";

    export default {
        name: "fitment-add-edit",
        components: {
            AssetDropZone,
            Datepicker,
            PreviewDropZone,
            FitmentStatusView,
            FitmentHistoryView,
            RejectComment
        },
        data() {
            return {
                processing: false,
                loading: {
                    isDocQrLoading: false,
                    isDocLoading: false,
                    isPdfLoading: false,
                    isPdfQrLoading: false,
                    isCDocLoading: false,
                    isCPdfLoading: false,
                    isCDocQrLoading: false,
                    isCPdfQrLoading: false,
                    isDocNotSignedAndQRCodeLoading: false,
                    isPdfNotSignedAndQRCodeLoading: false
                },
                show: false,
                isPageLoadInit: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                customerFilter: initFilterModel(),
                employeeFilter: initFilterModel(),
                fitment: {
                    id: null,
                    ownerClient: {},
                    evlObjectType: 'Fitment',
                    evlGoalType: null,
                    evlContractAmount: 0,
                    prepayment: 0,
                    employee: {},
                    evlValueType: 'Market',
                    evlPropertyType: '',

                    debtor: '',
                    letterNumber: null,
                    contractDate: null,
                    displayReport: false,
                    hasCustomerClient: false,
                    customerClient: null,
                    powerOfAttorneyDate: null,
                    powerOfAttorneyNumber: null,
                    evaluationFitments: [],

                    letterFiles: [],
                    actOfSaleFiles: [],
                    decisionFiles: [],
                    executivePlaylistFiles: [],
                    checkPaymentFiles: [],// to'lov haqidagi hujjatlar
                    appraisalStatusEnum: 'Unreviewed',
                    evaluationRespectiveType: "OTHER",
                    tenderContractDate: null,
                    tenderContractNumber: null,
                    evaluatorIdea: '',
                    evaluatorRestrictiveTerms: ''
                },
                tenderContractDate: null,
                contractDate: null,
                powerOfAttorneyDate: null,
                owners: [],
                customers: [],
                employees: [],
                goalTypes: EVL_GOAL_TYPES,
                propertyTypes: EVL_PROPERTY_TYPES,
                evaluationRespectiveTypes: [],
                status: null,
                isDirector: false,
                isAppraiser: false
            }
        },
        validations() {
            return {
                fitment: {
                    ownerClient: {
                        required: required
                    },
                    customerClient: {
                        required: requiredUnless(() => {
                            return !(this.fitment.hasCustomerClient);
                        })
                    },
                    powerOfAttorneyNumber: {
                        required: requiredUnless(() => {
                            return !(this.fitment.hasCustomerClient);
                        })
                    },
                    evlGoalType: {
                        required: required
                    },
                    evlPropertyType: {
                        required: required
                    },
                    employee: {
                        id: {
                            required: required
                        }
                    },
                    letterFiles: {
                        required: requiredUnless(() => {
                            return this.isMib || this.fitment.entiteCreateType === 'EXPERT2';
                        }),
                        minLength: minLength(1)
                    },
                    actOfSaleFiles: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    decisionFiles: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        }),
                        minLength: minLength(1)
                    },
                    // MIB
                    debtor: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    letterNumber: {
                        required: requiredUnless(() => {
                            return !(this.isOrgTypeMib);
                        })
                    },
                    evaluationRespectiveType: {
                        required: required
                    },
                    tenderContractNumber: {
                        required: requiredUnless(() => {
                            return !this.isTenders;
                        })
                    }
                },
                contractDate: {
                    required: requiredUnless(() => {
                        return !this.isOrgTypeMib;
                    })
                },
                tenderContractDate: {
                    required: requiredUnless(() => {
                        return !this.isTenders;
                    })
                },
                powerOfAttorneyDate: {
                    required: requiredUnless(() => {
                        return !(this.fitment.hasCustomerClient);
                    })
                }
            };
        },
        computed: {
            ...mapState(['profile']),
            isOwnerTypePhysical() {
                return !!(this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Physical');
            },
            isOwnerTypeLegal() {
                return !!(this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Legal');
            },
            isMib() {
                return !!(this.fitment.ownerClient && this.fitment.ownerClient.organizationType && this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');

            },
            isOrgType() {
                return !!(this.fitment.ownerClient &&
                    this.fitment.ownerClient.organizationType &&
                    (this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION'));
            },

            isOrgTypeMib() {
                return !!(this.fitment.ownerClient &&
                    this.fitment.ownerClient.organizationType &&
                    (this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.fitment.ownerClient.organizationType === 'CUSTOMS_ADMINISTRATION'));
            },
            documentOrPassportLbl() {
                if (this.fitment) {
                    if (this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Legal')
                        return "asset.document";
                    else
                        return "asset.passport";
                } else {
                    return "asset.passport";
                }
            },
            canConfirm() {
                return this.fitment.appraisalStatusEnum === 'Rated' && this.hasPermission('NEW_FITMENT_CONFIRM');
            },
            canReEvaluate() {
                return (this.fitment.appraisalStatusEnum === 'Rated' || this.fitment.appraisalStatusEnum === 'Confirmed') && this.hasPermission('NEW_FITMENT_REEVALUATE');
            },
            canSave() {
                return (this.fitment.entiteCreateType === 'API_EXARID' && !this.fitment.appraisalStatusEnum || this.fitment.appraisalStatusEnum === 'Unreviewed' || this.fitment.appraisalStatusEnum === 'NotFullyEvaluated' || this.fitment.appraisalStatusEnum === 'SentToComplement');
            },
            canEvaluate() {
                return (this.fitment.appraisalStatusEnum === 'Unreviewed');
            },
            showReportButton() {
                return (this.fitment.appraisalStatusEnum === 'Rated' || this.fitment.appraisalStatusEnum === 'Confirmed') && this.fitment.id && this.fitment.id > 0;
            },
            sendToMIBAssetReport() {
                return (this.fitment.appraisalStatusEnum === 'Rated' || this.fitment.appraisalStatusEnum === 'Confirmed') && this.fitment.id && this.fitment.id > 0;
            },
            checkPaymentLbl() {
                return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
            },
            isPaid() {
                return this.fitment.evlAmountPaid > 0;
            },
            canReject() {
                return this.hasPermission('NEW_FITMENT_EDIT')
                    && (this.fitment.appraisalStatusEnum === 'Unreviewed' || (this.fitment.appraisalStatusEnum === 'NotFullyEvaluated' && this.isUserDirector))
                    && !this.fitment.hasAppraiserReportEsp;
            },
            canRemoveFile() {
                return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status!=='Rejected' && this.hasPermission('NEW_FITMENT_IMAGE_DELETE')
            },
            canSendAgent() {
                return (this.fitment.appraisalStatusEnum === 'SentToComplement' && this.fitment.entiteCreateType === 'EXPERT2' && this.hasPermission('NEW_FITMENT_EDIT'))
            },
            isTenders() {
                return this.fitment.evaluationRespectiveType === 'TENDERS';
            },
            isUserDirector() {
              return this.profile && this.profile.username === 'shohrux';
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                const promises = [];
                if (id && id > 0) {
                    vm.isPageLoadInit = true;
                    promises.push(this.$http.get('fitment/' + id));

                    Promise.all(promises).then(function (values) {
                        if (values.length >= 0) {
                            const editData = values[0].data;
                            if (!editData.evlGoalType) {
                                editData.evlGoalType = '';
                            }
                            vm.contractDate = parseDate(editData.contractDate);
                            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
                            vm.tenderContractDate = parseDate(editData.tenderContractDate);
                            vm.fitment = editData;
                            vm.fitment.employee = {};
                            if (editData.employeeId && editData.employeeName) {
                                vm.fitment.employee.id = editData.employeeId;
                                vm.fitment.employee.text = editData.employeeName;
                            }

                            vm.status = editData.appraisalStatusEnum;
                            vm.isPageLoadInit = false;
                        }
                    });
                }
            },
            cancel() {
                this.$router.push('/fitment/list');
            },
            save() {
                this.saveAndGo();
            },
            saveAndGo() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                if (this.fitment.prepayment && !(this.fitment.prepayment >= 0 && this.fitment.prepayment <= 100)) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
                        type: 'warning'
                    });
                    return;
                }

                this.processing = true;

                if (this.contractDate) {
                    this.fitment.contractDate = formatDate(this.contractDate);
                }

                if (this.tenderContractDate) {
                    this.fitment.tenderContractDate = formatDate(this.tenderContractDate);
                }

                if (this.powerOfAttorneyDate) {
                    this.fitment.powerOfAttorneyDate = formatDate(this.powerOfAttorneyDate);
                }

                if (this.fitment.employee) {
                    this.fitment.employeeId = this.fitment.employee.id;
                }

                if (this.isMib) {
                    this.fitment.evlContractAmount = 0;
                }
                this.$http.post('fitment/save', this.fitment)
                    .then(res => {

                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/fitment/edit/' + res.data.data.id);
                            this.editFitment(res.data.data.id);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.realEstate.statusWarning'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },

            editFitment(id) {
                const vm = this;
                const promises = [];
                if (id && id > 0) {
                    promises.push(this.$http.get('fitment/' + id));
                    Promise.all(promises).then(function (values) {
                        if (values.length >= 0) {
                            const editData = values[0].data;
                            if (!editData.evlGoalType) {
                                editData.evlGoalType = '';
                            }
                            vm.contractDate = parseDate(editData.contractDate);
                            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
                            vm.fitment = editData;
                            vm.fitment.employee = {};
                            if (editData.employeeId && editData.employeeName) {
                                vm.fitment.employee.id = editData.employeeId;
                                vm.fitment.employee.text = editData.employeeName;
                            }
                        }
                    });
                }
            },

            addEditPushItem(itemId, fitmentId) {
                this.$router.push({
                    path: '/fitment/item/edit/'+itemId+'/'+fitmentId,
                    query: {entiteCreateType: this.fitment.entiteCreateType}
                });
            },
            addFitment() {
                this.$router.push({
                    path: '/fitment/item/new/'+this.fitment.id,
                    query: {entiteCreateType: this.fitment.entiteCreateType}
                });
            },
            onOwnerSearch(searchTxt, loading) {
                loading(true);
                this.owners = [];
                this.ownerFilter.search = searchTxt;
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onOwnerFocus() {
                this.owners = [];
                this.ownerFilter.search = '';
                this.$http.post('customer/search', this.ownerFilter)
                    .then(res => {
                        this.owners = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerSearch(searchTxt, loading) {
                loading(true);
                this.customers = [];
                this.customerFilter.search = searchTxt;
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onCustomerFocus() {
                this.customers = [];
                this.customerFilter.search = '';
                this.$http.post('customer/search', this.customerFilter)
                    .then(res => {
                        this.customers = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeSearch(searchTxt, loading) {
                loading(true);
                this.employees = [];
                this.employeeFilter.search = searchTxt;
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onEmployeeFocus() {
                this.employees = [];
                this.employeeFilter.search = '';
                this.$http.post('employes/search', this.employeeFilter)
                    .then(res => {
                        this.employees = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            showDeleteFitmentItemDialog(item, index) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('asset.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('fitment/item/delete/' + item.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.building.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.fitment.evaluationFitments.splice(index, 1);
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.building.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            changeStatus(status) {
                this.processing = true;
                this.isPageLoadInit = true;

                this.$http.get('contractRegion/check-contract/' + this.fitment.id + "/Fitment").then(response => {
                    if (response.data.status !== 'SUCCESS' || response.data.status === 'SUCCESS' && response.data.code === 'ALLOWED') {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: response.data.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#dd3333',
                            confirmButtonText: 'Давом этиш',
                            cancelButtonText: 'Бекор қилиш'
                        }).then((result) => {
                            if (result.value) {
                                this.sendChangesToServer(status);
                            }
                            this.processing = false;
                        });
                    } else {
                        this.sendChangesToServer(status);
                    }
                });
            },
            sendChangesToServer(status) {
                this.$http.post('change/status', {
                    id: this.fitment.id,
                    appraisalStatusEnum: status,
                }).then(res => {
                    if (res && res.data) {
                        if (res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('fitment.statusSuccess'),
                                type: 'success'
                            });
                            this.fitment.appraisalStatusEnum = status;
                            this.status = status;
                            if (status === 'Confirmed') {
                                if (this.fitment.hasEsp) {
                                    this.openSignPageDirector(this.fitment);
                                }
                            } else if (status === 'Rated') {
                                if (this.fitment.hasEsp) {
                                    this.openSignPageAppraiser(this.fitment);
                                }
                            } else if (status === 'Unreviewed') {
                                window.location.reload();
                            }

                        } else if (res.data.status === 'ERROR') {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('asset.statusWarning'),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                    this.isPageLoadInit = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('asset.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                    this.isPageLoadInit = false;
                });
            },
            reportPdf: function (fitment) {
                this.loading.isPdfLoading = true;
                this.downloadFile('/v2/fitmentReport/pdf/' + fitment.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + fitment.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isPdfLoading');
            },
            notSignedAndQRCodeReportPdf: function (fitment) {
                this.loading.isPdfNotSignedAndQRCodeLoading = true;
                this.downloadFile('/v2/fitmentReportNotSignedAndQRCode/pdf/' + fitment.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + fitment.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isPdfNotSignedAndQRCodeLoading');
            },
            reportPdfQrCode: function (fitment) {
                this.loading.isPdfQrLoading = true;
                this.downloadFile('/v2/fitmentReport/pdf/' + fitment.hashUuid + '/WITH_QR_CODE',
                    'Хисобот ' + fitment.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isPdfQrLoading');
            },
            reportDoc: function (fitment) {
                this.loading.isDocLoading = true;
                this.downloadFile('/v2/fitmentReport/doc/' + fitment.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + fitment.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isDocLoading');
            },
            notSignedAndQRCodeReportDoc: function (fitment) {
                this.loading.isDocNotSignedAndQRCodeLoading = true;
                this.downloadFile('/v2/fitmentReportNotSignedAndQRCode/doc/' + fitment.hashUuid + '/WITH_SIGNATURE',
                    'Хисобот ' + fitment.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isDocNotSignedAndQRCodeLoading');
            },
            reportDocQrCode: function (fitment) {
                this.loading.isDocQrLoading = true;
                this.downloadFile('/v2/fitmentReport/doc/' + fitment.hashUuid + '/WITH_QR_CODE',
                    'Хисобот ' + fitment.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isDocQrLoading');
            },
            downloadFile: function (url, name, type, loading) {
                this.$http.get(url, {responseType: 'arraybuffer'})
                    .then(response => {
                        let blob = new Blob([response.data], {type: type});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = name;
                        link.click();
                        this.loading[loading] = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading[loading] = false;
                        if (err.response && err.response.status === 429) {
                          this.$reportSwal(err.response, () => this.downloadFile(url, name, type, loading))
                        }
                    })
            },
            contractDocQrCode: function (fitment) {
                this.loading.isCDocQrLoading = true;
                this.downloadFile('/v2/fitmentContract/doc/' + fitment.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + fitment.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isCDocQrLoading');
            },
            contractDoc: function (fitment) {
                this.loading.isCDocLoading = true;
                this.downloadFile('/v2/fitmentContract/doc/' + fitment.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + fitment.ownerClient.fullName + '.doc',
                    'application/doc',
                    'isCDocLoading');
            },
            contractPdf: function (fitment) {
                this.loading.isCPdfLoading = true;
                this.downloadFile('/v2/fitmentContract/pdf/' + fitment.hashUuid + '/WITH_SIGNATURE',
                    'Шартнома ' + fitment.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfLoading');
            },
            contractQrCodePdf: function (fitment) {
                this.loading.isCPdfQrLoading = true;
                this.downloadFile('/v2/fitmentContract/pdf/' + fitment.hashUuid + '/WITH_QR_CODE',
                    'Шартнома ' + fitment.ownerClient.fullName + '.pdf',
                    'application/pdf',
                    'isCPdfQrLoading');
            },
            sendReportToMIBAsset: function (fitment) {
                this.processing = true;
                this.$http.get('/sendApiMibConfirmReport/pdf/' + fitment.id + '/WITH_QR_CODE/Fitment', {responseType: 'arraybuffer'})
                    .then(response => {
                        if (response && response.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('realEstate.report.titleQrCode'),
                                type: 'success'
                            });
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.common.error'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            showReport: function () {
                this.$http.post('fitment/show-report/' + this.fitment.id + '/' + this.fitment.displayReport)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showReportSuccess'),
                                type: 'success'
                            });
                            this.fitment.appraisalStatusEnum = status;
                        } else if (res && res.data && res.data.status === 'FAIL') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                                type: 'success'
                            });
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.showReportError'),
                            type: 'error'
                        });
                    });
            },
            getEvaluationRespectiveType() {
                this.$http.get('/evaluationRespectiveType').then(response => {
                    this.evaluationRespectiveTypes = response.data;
                }, err => {
                    console.log(err)
                });
            },
            deleteFitment: function (fitment) {
                this.processing = true;
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('fitment.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('delete/appraisal/' + fitment.id)
                            .then((res) => {
                                console.log(res.data);
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('fitment.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.$router.push('/fitment/list');
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('fitment.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    } else {
                        this.processing = false;
                    }
                });
            },
            rejectOrder() {
                this.$eventBus.$emit('RejectComment', this.fitment.id, false, "Fitment");
            },
            openSignPageDirector: function (fitment) {
                this.processing = true;
                this.$http.get('/esign/director/' + fitment.id + '/Fitment')
                    .then(response => {
                        if (response && response.status === 200) {
                            window.open(response.data.data);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: response.data.message,
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            openSignPageAppraiser: function (fitment) {
                this.processing = true;
                this.$http.get('/esign/appraiser/' + fitment.id + '/Fitment')
                    .then(response => {
                        if (response && response.status === 200) {
                            window.open(response.data.data);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: response.data.message,
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t('messages.common.error'),
                            type: 'warning'
                        });
                        this.processing = false;
                    })
            },
            isRoleDirector() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role == "ROLE_DIRECTOR") {
                        return this.isDirector = true;
                    }

                }
            },
            isRoleAppraiser() {
                const authorities = this.$store.state.profile.authorities;
                for (const role of authorities) {
                    if (role == "ROLE_APPRAISER") {
                        return this.isAppraiser = true;
                    }
                }
            },
            sendingExpert2ToAgent() {
                this.processing = true;
                this.isPageLoadInit = true;
                this.$http.get('send/expert2/agent/' + this.fitment.id).then(response => {
                    this.$swal({
                        title: this.$t('messages.common.success'),
                        text: response.data.message,
                        type: 'success'
                    });
                    this.processing = false;
                }).catch(err => {
                    console.log(err);
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('messages.common.error'),
                        type: 'warning'
                    });
                    this.processing = false;
                });
            },
            sendEvaluationObjectToIdentification: function (fitment) {
              this.processing = true;
              this.$http.get('/auto/send-evaluation-object-identification/' + fitment.id)
                  .then(response => {
                    if (response && response.status === 200) {
                      this.$router.push('/fitment/plus/complement/' + this.fitment.id);
                    } else {
                      this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: response.data.message,
                        type: 'warning'
                      });
                    }
                    this.processing = false;
                  })
                  .catch(err => {
                    console.log(err);
                    this.$swal({
                      title: this.$t('messages.common.warning'),
                      text: this.$t('messages.common.error'),
                      type: 'warning'
                    });
                    this.processing = false;
                  })
            }
        },
        created() {
            this.init();
            this.getEvaluationRespectiveType();
            this.isRoleDirector();
            this.isRoleAppraiser();
        }
    }
</script>

<style scoped>

</style>
